module.exports = __webpack_public_path__ + "static/media/modalBacker@3x.eaf55606.png";